import ajax from '@client/components/ajax'; // NOTE: old
import { LiteUser } from '@client/new/common/LiteUser.mapper';

import { TextField } from '@client/new/components/basic';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { PrimaryButton } from '@client/new/components/button';
import { pickObject } from '../../../helpers/general';
import { InfoTip } from '../InfoTip';
import { trackEvent } from '@services/tracking';

export const MetaPixelForm = (p: { creator: LiteUser }) => {
  const initial = pickObject(p.creator, [
    'facebookConversionApiAccessToken',
    'facebookPixelId',
  ]);
  const [state, setState] = useState(initial);
  const [isSaving, setIsSaving] = useState(false);

  const submit = () => {
    setIsSaving(true);

    trackEvent({
      type: 'Meta Configuration Saved',
      payload: {},
    });

    ajax
      .upsertInfluencer({ ...(p.creator as any), ...state })
      .then(() => toast.success('Meta configuration was saved!'))
      .catch((err) =>
        toast.error('Error saving Meta configuration: ' + err.message),
      )
      .finally(() => setIsSaving(false));
  };

  return (
    <div className="flex flex-col gap-5 pt-4">
      <InfoTip>
        After connecting your Meta Pixel, test to verify that everything has
        been set up correctly. Using the Chrome Browser? Check out the{' '}
        <a
          href="https://www.facebook.com/business/help/1700857106877546?id=1205376682832142"
          target="_blank"
          rel="noreferrer"
        >
          Pixel Helper extension from Meta
        </a>{' '}
        to test your Pixel implementation! Testing can also be done using the
        Test Events tool in your{' '}
        <a
          href="https://www.facebook.com/business/help/898185560232180?id=1205376682832142"
          target="_blank"
          rel="noreferrer"
        >
          Meta Events Manager.
        </a>
      </InfoTip>

      <div className="grid md:grid-cols-2 gap-5">
        <TextField
          label="Pixel ID"
          value={state.facebookPixelId || ''}
          onChange={(e) =>
            setState((s) => ({ ...s, facebookPixelId: e.target.value }))
          }
          placeholder="Please enter facebook pixel"
          required
        />
        <TextField
          label="Access Token (optional)"
          value={state.facebookConversionApiAccessToken || ''}
          onChange={(e) =>
            setState((s) => ({
              ...s,
              facebookConversionApiAccessToken: e.target.value,
            }))
          }
          placeholder="Please enter access token"
        />
      </div>

      <PrimaryButton
        className="max-w-[120px] self-end"
        onClick={submit}
        isLoading={isSaving}
        disabled={!state.facebookPixelId}
      >
        Save
      </PrimaryButton>
    </div>
  );
};
